:host {
  display: block;

  .container {
    position: relative;
    width: 100%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;

    lilu-img {
      max-width: 100%;
      max-height: 100%;
      width: 100%;
      height: 100%;
    }

    &:hover {
      .controls {
        visibility: visible;
      }
    }

    &.is-hover {
      .controls {
        &.show {
          visibility: visible;
        }
      }
    }

    .controls {
      display: none;

      &.show {
        pointer-events: none;
        display: flex;
        justify-content: space-between;
        width: calc(100% - 10px);
        top: calc(50% - 7px);
        left: 5px;
        position: absolute;

        @media screen and (min-width: 1367px) {
          top: calc(100% - 14px - 18px);
          width: fit-content;
          justify-content: flex-start;
          visibility: hidden;
        }
      }

      .control {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        border: none;
        font-family: var(--primary-icon-font);
        font-size: 8px;
        color: var(--color-nero);
        background-color: var(--color-bleached-silk);
        cursor: pointer;
        pointer-events: initial;

        @media screen and (min-width: 768px) {
          width: 25px;
          height: 25px;
          font-size: 12px;
        }
      }

      .prev {
        margin-right: 14px;

        @media screen and (min-width: 768px) {
          margin-right: 10px;
        }

        &::before {
          content: '\e80d';

          @media screen and (min-width: 768px) {
            left: -1px;
            top: -2px;
          }
        }
      }

      .next {
        &::before {
          content: '\e80c';

          @media screen and (min-width: 768px) {
            left: 1px;
            top: -2px;
          }
        }
      }
    }
  }
}
